import { apiHost } from '@libs/providers/api-host.provider';

const url = `${apiHost()}/web/vacancies`;

export enum HttpStatuses {
  received = 200,
  created = 201,
  notFound = 404,
  unprocessable = 422,
}

export function getVacancies(
  skip: number,
  take?: number,
  search?: string,
  locationTitle?: string,
  department?: string,
) {
  const query = new URLSearchParams({
    skip: String(skip),
    take: String(take),
  });
  if (search) {
    query.set('search', search);
  }

  if (locationTitle) {
    query.set('locationTitle', locationTitle);
  }
  if (department) {
    query.set('department', department);
  }

  return fetch(`${url}?${query}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}

export function getVacancy(slug: string) {
  return fetch(`${url}/${slug}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}
